import React from 'react';

import Admin from 'hive-admin';

import {
  ADMIN as FILTERS_ADMIN,
  SELLER as FILTERS_SELLER,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
  SELLER as COLUMNS_SELLER,
} from './columns';

import {
  ADMIN as FIELDS_ADMIN,
  SELLER as FIELDS_SELLER,
} from './fields';

import { getI18nFields } from '../../helpers/i18n';

export default [
  ['ADMIN', {
    path: '/abandoned-carts',
  }],
  ['SELLER', {
    path: '/store/abandoned-carts',
    archiveLoadUrl: '/abandoned-carts',
  }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
        forRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_ADMIN]
      : forRole === 'SELLER'
      ? [COLUMNS_SELLER, FILTERS_SELLER, FIELDS_SELLER]
      : []
    );
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Abandoned Carts',
      // icon: 'ordered-list',
      archiveConfig: {
        title: 'Abandoned',
        label: 'Abandoned',
        // icon: 'ordered-list',
        hidden: [
          [
            'condition.checkViewer',
            'role', '!==', forRole,
          ],
        ],
        getCreateButtonPath: () => null,
      },
      singleLoadUrl: `/abandoned-carts/:id/?${
        [
          'store=true',
        ].join('&')
      }`,
      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
        getPageFields: getI18nFields,
        renderHeaderTitle: (props) => (
            props.data?.name
          ? (
              <span style={{ textTransform: 'capitalize' }}>
                {props.data.name || 'N/A'}
              </span>
            )
          : 'Abandoned Cart'
        ),
      },
      renderHeaderDescription: (props) => (
          props.data?.email
        ? props.data.email
        : null
      ),
      singleEditConfig: {
        actions: [
          // ['ActionSave', {
          //   handleSuccess: (data, props) => props.reload(),
          // }],
          // ['ActionDelete'],
        ],
      },
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', forRole,
            forRole === 'ADMIN'
          ? '/store/abandoned-carts'
          : forRole === 'SELLER'
          ? '/abandoned-carts'
          : null,
        ],
      ],
      columns: COLUMNS,
      filters: FILTERS,
      fields: FIELDS,
      ...config,
    }]).pages);
    return pages;
  },
  [],
);
